import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  static targets = ['popover']

  declare readonly popoverTarget: HTMLDivElement

  toggle(e: MouseEvent): void {
    this.popoverTarget.togglePopover()
    e.preventDefault()
  }
}
